import { accessRolesTranslation } from '@/AccessRoles/ui/AccesRolesTranslation';
import { OreButton } from '@edenredespana/oreneta';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalMode } from '../../domain/ProfileTypes';

interface ProfileModalActionsProps {
  onCancel: () => void;
  isDirty: boolean;
  mode?: ModalMode;
}

export const ProfileModalActions: React.FC<ProfileModalActionsProps> = ({ 
  onCancel, 
  isDirty,
  mode = 'create' 
}) => {
  const { t } = useTranslation();
  return (
    <>
      <OreButton onClick={onCancel} size="small" category="secondary">
        {t(accessRolesTranslation.modal.actions.cancelar)}
      </OreButton>
      <OreButton
      type="submit"
      size="small"
      category={'primary'}
      disabled={mode === 'edit' && !isDirty}>
      {mode === 'edit' 
        ? t(accessRolesTranslation.modal.actions.save)
        : t(accessRolesTranslation.modal.actions.create)
      }
    </OreButton>
  </>
  );
};
